import getAxiosInstance from 'api';
import { useEffect, useState } from 'react';
import BOIReportHistory from './boiReportHistory';

const BOIReport = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [walletData, setWalletData] = useState([]);


  const fetchWalletData = () => {
    getAxiosInstance(
      `businessPartner/walletDetails`,
      'get',
      {},
      {
        'journey-type': 'wallet',
      }
    ).then((res) => {
      setWalletData(res.data?.data?.products || []);
    });
  };

  useEffect(() => {
    fetchWalletData();
  }, []);

  return (
    <>
      <BOIReportHistory />
    </>
  );
};

export default BOIReport;